import { BanUserModal } from './BanUserModal'
import { withBanUserModal } from './withBanUserModal'

const ConnectedBanUserModal = withBanUserModal(BanUserModal)

export { ConnectedBanUserModal as BanUserModal }
